export default `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 600 600" style="enable-background:new 0 0 800 600;" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <style type="text/css">
	.st0{fill:#8247E5;}
	.st1{clip-path:url(#SVGID_00000170985874484226784740000010197121833159053193_);}
	.st2{fill:#FFFFFF;}
</style>
  </defs>
  <path class="st0" d="M 296.8 45.4 C 437.2 45.4 551 159.2 551 299.6 C 551 440 437.2 553.7 296.9 553.7 C 156.5 553.7 42.8 439.9 42.8 299.6 C 42.7 159.2 156.5 45.4 296.8 45.4 Z"/>
  <g transform="matrix(1, 0, 0, 1, -103, 0)">
    <defs>
      <rect id="SVGID_1_" x="231.5" y="155.3" width="333.1" height="291.9"/>
    </defs>
    <clipPath id="SVGID_00000119824040907289936360000005545950198423505064_">
      <rect x="231.5" y="155.3" width="333.1" height="291.9" style="overflow: visible;"/>
    </clipPath>
    <g style="clip-path:url(#SVGID_00000119824040907289936360000005545950198423505064_);">
      <path class="st2" d="M483.1,244.2c-6.1-3.5-13.9-3.5-20.8,0L413.7,273l-33,18.3L333,320c-6.1,3.5-13.9,3.5-20.8,0l-37.3-22.7&#10;&#9;&#9;&#9;c-6.1-3.5-10.4-10.5-10.4-18.3v-43.6c0-7,3.5-13.9,10.4-18.3l37.3-21.8c6.1-3.5,13.9-3.5,20.8,0l37.3,22.7&#10;&#9;&#9;&#9;c6.1,3.5,10.4,10.5,10.4,18.3v28.8l33-19.2v-29.6c0-7-3.5-13.9-10.4-18.3l-69.4-41c-6.1-3.5-13.9-3.5-20.8,0L242,198.9&#10;&#9;&#9;&#9;c-6.9,3.5-10.4,10.5-10.4,17.4v81.9c0,7,3.5,13.9,10.4,18.3l70.3,41c6.1,3.5,13.9,3.5,20.8,0l47.7-27.9l33-19.2l47.7-27.9&#10;&#9;&#9;&#9;c6.1-3.5,13.9-3.5,20.8,0l37.3,21.8c6.1,3.5,10.4,10.5,10.4,18.3v43.6c0,7-3.5,13.9-10.4,18.3l-36.4,21.8&#10;&#9;&#9;&#9;c-6.1,3.5-13.9,3.5-20.8,0L425,384.5c-6.1-3.5-10.4-10.5-10.4-18.3v-27.9l-33,19.2v28.8c0,7,3.5,13.9,10.4,18.3l70.3,41&#10;&#9;&#9;&#9;c6.1,3.5,13.9,3.5,20.8,0l70.3-41c6.1-3.5,10.4-10.5,10.4-18.3v-82.8c0-7-3.5-13.9-10.4-18.3L483.1,244.2z"/>
    </g>
  </g>
</svg>`;
